"use client";

import React, { useState, useEffect, useRef } from "react";
import TabItem from "./TabItem";
import TabItemContent from "./TabItemContent";
import { useScrollToHash } from "@/helpers/useScrollToHash";

const Tabs = ({ title, tabsId, items, withinContainer, menu }) => {
  const [activeTab, setActiveTab] = useState("#panel-0");
  const hashIndex = useScrollToHash(items, "tabs");

  useEffect(() => {
    {
      items.map((item, index) => {
        if (!item.nested?.data && !item.text) {
          setActiveTab(`#panel-${index + 1}`);
          return;
        }
      });
    }
  }, []);

  useEffect(() => {
    if (hashIndex !== null) setActiveTab(`#panel-${hashIndex}`);
  }, [hashIndex]);

  const clickTabHandler = (e) => {
    e.preventDefault();
    setActiveTab(e.target.hash);
  };

  const element = (
    <div className="tps-tabbed-content-wrapper cell margin-bottom-3">
      <ul
        className="tps-tabs rid-x medium-text-center no-bullet tabs"
        id={`tps-tabs-${tabsId}`}
        data-deep-link="true"
        data-allow-all-closed="true"
        data-responsive-accordion-tabs="accordion tablet-tabs"
        role="tablist"
      >
        {items.map((item, index) => {
          if (
            (item.nested?.data !== null &&
              item.nested?.data?.attributes?.publishedAt !== null) ||
            item?.text
          ) {
            return (
              <TabItem
                index={index}
                key={index}
                title={item?.title}
                clickTabHandler={clickTabHandler}
                activeTab={activeTab}
              />
            );
          }
        })}
      </ul>

      <div
        className="tps-tabs-content"
        data-tabs-content="tps-tabs-theconservatorycirclecommittee"
      >
        {items.map((item, index) => {
          if (
            (item.nested?.data !== null &&
              item.nested?.data?.attributes?.publishedAt !== null) ||
            item?.text
          ) {
            return (
              <TabItemContent
                index={index}
                key={index}
                text={item?.text}
                activeTab={activeTab}
                linkToButtonReplacementWords={
                  item?.linkToButtonReplacementWords
                }
                accordionHtmlHack={item?.accordionHtmlHack}
                nested={item?.nested}
                menu={menu}
              />
            );
          }
        })}
      </div>
    </div>
  );

  return withinContainer ? (
    <div className={"grid-container"}>{element}</div>
  ) : (
    element
  );
};

export default Tabs;
